module.exports = global.config = {
    bURL : "https://amanorabeautylounge.com/api/",
    logo2 : "./assets/images/amanora-logo2.png",
    RZ_TEST_KEY: 'rzp_test_AMeoOcF462XHWb',
    RZ_LIVE_KEY: 'rzp_live_rJQ5fJ9KZP9SHk',
};